Config = require('resources/assets/coffee/Core/LaravelJs/Config/Repository').Repository
Trans = require('resources/assets/coffee/Core/LaravelJs/Translation/Translator').Translator
MapSidebar = require('resources/assets/coffee/Core/MapSidebar').MapSidebar
OverlayStorage = require('resources/assets/coffee/Core/OverlayStorage').OverlayStorage
Storage = require('resources/assets/coffee/Core/Storage').Storage

require('public/js/jquery-ui/jquery-ui.custom.min')
require('public/bootstrap-2.3.1/docs/assets/js/bootstrap')
require('public/js/datatables/jquery.dataTables')
require('public/js/datatables/datatables-bootstrap')

if L?
    require('public/js/Leaflet.Pancontrol/src/L.Control.Pan')

class exports.Application

    options: {
        useMap: true
        useSidebar: true
        useNavResize: true
    }


    constructor: (options = {}) ->
        # Debugging information
        @handlerStackMaxSize = 10
        @eventStack = []
        @eventStackMaxSize = 40

        @resolverPaths = {
            'grower': 'resources/assets/coffee/Grower'
            'portal': 'resources/assets/coffee/Portal'
            'admin': 'resources/assets/coffee/Admin'
            'core': 'resources/assets/coffee/Core'
            'bower': 'public/bower_components'
            'yarn': 'node_modules'
            'public': 'public/js'
        }

        @current_page
        @navLinks ?= {}
        @popups =
            'MissingFileDialog': 'core::MissingFileDialog'
            'NonExistentUserDialog': 'core::NonExistentUserDialog'

        window.DEBUG = false

        @options = $.extend(@options, options)

        $('#reload-site button').bind 'click', () ->
            window.location.reload(true)

        $('#download-complete a').bind 'click', () ->
            $('#download-complete').toggle('slide')
            $.post('backend/grower/download/get-complete-data-packages').then (response) =>
                package_ids = response.data

                for id in package_ids
                    window.open "backend/grower/download/download?id=#{id}"

    boot: () ->
        @storage = new Storage()

        @initGlobals()

        if @options.useMap
            @initMap()

        if @options.useSidebar
            @initSidebar()

        @init()

        $(window).trigger('app:booting')

        if @options.useNavResize
            @initNavbarResize()

        # Initialize the site down for maintenance dialog
        $('.down-dialog').modal
            backdrop: 'static'
            keyboard: false
            show: false

        $(window).trigger('app:ready', this)



    initNavbarResize: () ->
        # This timeout allows ui-router to properly generate
        # the href properties on the navigation tabs nested
        # under the responsive nav dropper. I believe this
        # is a bug in ui-router itself
        setTimeout () =>
            ResizeDropper = @loadClass 'core::ResponsiveNavDropper'
            @_resizeDropper = new ResizeDropper()
            @_resizeDropper.attach $('#nav_primary_links'), 'More', 80
        , 0


    initSidebar: () ->
        map = @map ? null
        @sidebar = new MapSidebar(map)


    destroyCurrentPage: () =>
        if @current_page?
            @current_page.destroy()

    doNavChange: (sel = null) =>
        elem = @nav_element_clicked
        if not elem?
            return

        @nav_element_clicked = null

        # hack until this is written in Angular and we can do things the 'right' way
        if sel?
            $(document).ajaxStop () ->
                $('div.sidebar_content .nav-tabs a').eq(sel).trigger 'click'
                $(document).unbind 'ajaxStop'
                return

        # Note: this kind of conflicts with the ng-class for Angularized pages,
        # but I don't think it causes any problems as long as we do it right..
        $('#nav_primary_links li, #nav_contact_link li').removeClass 'active'
        @deactivateNavLinks()
        $(elem).parents('li').addClass 'active'

        # If going to an Angular page, just destroy the current handler.
        sref = $(elem).attr('ui-sref')
        if sref? and sref isnt ''
            @destroyCurrentPage()
            return

        handler = $(elem).data('handler') or $(elem).text()
        handler = handler.replace /\s+/g, ''
        name = handler.toLowerCase()

        path = List.retrieve @navLinks, handler

        if not path
            alert "No navLink handler found: #{handler}.
                Check the navLinks object in the #{App.constructor.name} application class"
            return

        # destroy the current handler
        @destroyCurrentPage()

        # create the new handler
        hClass = @loadClass path
        @current_page = new hClass(name)

        @current_page.navBtn = $(elem).parents 'li'
        @current_page.init()

        if @sidebar?
            if @current_page.sidebar_open is true
                @sidebar.open()
            else if @current_page.sidebar_open is false
                @sidebar.close()


    init: () ->
        # Check for any available data packages and show if necessary
        $.post('backend/grower/download/get-complete-data-packages').then (response) =>
            packages = response.data.length
            $('#download-complete').toggle('slide') if packages

    initGlobals: () ->
        window.Config = new Config @getConfig() ? {}
        window.Trans = new Trans window.Config
        window.Spinner = @load 'bower::spinjs/spin'

        $(window).trigger('config:ready', this)

        @loadGlobalClass 'core::DependencyInjection'
        @loadGlobalClass 'core::KoModel'
        @loadGlobalClass 'core::Handler'
        @loadGlobalClass 'core::DialogHandler'
        @loadGlobalClass 'core::FullPageHandler'
        @loadGlobal 'core::List', 'List'
        @loadGlobal 'bower::lodash/dist/lodash', '_'
        @loadGlobal 'moment', 'moment'
        @loadGlobal 'bower::phpjs/src/php/strings/strnatcasecmp', 'strnatcasecmp'

        window.TAFFY = @load('public::taffydb/taffy-with-natsort').taffy
        window.ko = @load('bower::knockout/dist/knockout')
        window.nedb = @load('public::nedb/nedb')
        @load('core::knockout/checkableButton')
        @load('core::knockout/valueTriggerChange')

        # Set up jsrender
        @load('bower::jsrender/jsrender')
        $.views.settings.delimiters('{!', '!}')

        @load('core::widget_multidelete')
        @load('core::widget_resizr')
        @load('core::widget_message_writer')
        @load('core::widget_listitems')
        @load('core::widget_myUploader')
        @load('public::smartresize/smartresize')
        @load('bower::jquery-maskedinputs/dist/jquery.maskedinput')
        @load('public::jquery.validationEngine')
        @load('public::jquery.validationEngine-en')
        @load('bower::jstree-dist/jquery.jstree')
        @load('bower::jquery-timepicker-jt/jquery.timepicker')
        @load('bower::bootstrapx-clickover/js/bootstrapx-clickover')
        @load('bower::select2/select2')
        # @load 'bower::qtip2/jquery.qtip'
        @load 'bower::bootstrap-daterangepicker/daterangepicker'
        @load 'core::handsontable/getRowOfSourceData'
        @load 'core::handsontable/status-cell-type'
        @load 'core::handsontable/better-autocomplete'
        @load 'core::handsontable/fancy-validation'
        @load 'core::handsontable/row-col-helpers'

        # Make sure plupload is plincluded
        window.mOxie = @load('bower::plupload/js/moxie.min').mOxie
        @load('bower::plupload/js/plupload.dev')
        @load('bower::plupload/js/jquery.plupload.queue/jquery.plupload.queue')

        touch = @loadClass 'core::utils/touch'
        touch.initialize()

        window.isDebug = @isDebug
        window.debugLog = @debugLog
        window.debugAlert = @debugAlert




    addPopup: (popupname, params = {}) =>
        pop = List.retrieve(@popups, popupname) ? popupname

        h = @loadClass pop

        if not h?
            throw new Error "Unable to create popup #{popupname}, class not found"
            return

        h = new h()
        h.loadLayoutPostOptions = params

        h.init()


    getConfig: () ->
        undefined

    initMap: () ->

        # If Leaflet isn't here (todo: import leaflet locally)
        # then stub some things so we can use the site somewhat
        if not L?
            window.L =
                Class:
                    extend: ( -> undefined )
                Util:
                    extend: ( -> undefined )
                GeoJSON: {}
            throw new Error 'Map not loaded; No Leaflet found.'
            @layer_store = new Storage()
            @layer_store.loadField = () ->
                undefined
            return

        App.load 'core::globals/modules'

        @layer_store = new OverlayStorage()

        # if mapbox wasn't loaded, the rest of this is useless
        if not L.mapbox?
            console.error 'Failed to load map' # don't stop execution though
            return

        maxZoom = if window.Config.get('app.locale') is 'en_AU' then 16 else 18
        L.mapbox.accessToken = 'pk.eyJ1IjoibXlmYXJtcyIsImEiOiJaY2gzXzJvIn0.Kh5pHZFlBBoMXbWMtl246A'

        @map = L.map 'map_canvas',
            zoomControl: false
            attributionControl:
                compact: true
            continuousWorld: false
            legendControl:
                position: 'topleft'
            minZoom: 2
            maxZoom: maxZoom
            interactive: false

        L.tileLayer 'https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=' + L.mapbox.accessToken,
            id: 'myfarms/clzjy3pnf016y01pa70lxfwbv',
        .addTo @map

        # Allow other places in the code (like fields edit) to turn this off to avoid a race condition
        App.recenterMap = true

        setTimeout () =>
            if App.recenterMap
                @map.setView user_address_lat_lng, 14
        , 1000

        # This creates a marker on the map at the users location, but only if they are on a mobile device.
        if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) )
            #@map.on 'locationfound',(location) =>
            @userMarker = L.marker(user_address_lat_lng).addTo @map

        # Add controls
        @map.addControl(new L.Control.Pan({ position: 'topright' }))
        @map.addControl(new L.Control.Zoom({ position: 'topright' }))
        @map.addControl(new L.control.scale({ metric: false }))

        @map.whenReady () =>
            # get user's location via browser
            @map.locate {
                setView: true
                watch: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
                maxZoom: 17
            }

        #This bit of code makes the marker update its position as the user moves
        if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) )
            @map.on 'locationfound', (location) =>
                @userMarker.setLatLng(location.latlng)

            $(window).trigger 'map_ready'

    load: (file) ->
        file = @_resolvePath file

        if file?
            return require(file)


    loadGlobal: (file, name) ->
        file = @_resolvePath file

        window[name] = @load file

        return window[name]

    loadClass: (file, classname = null) ->
        file = @_resolvePath file

        if not classname?
            classname = @_findClassname(file)

        loaded =  @load(file)

        if not loaded[classname]?
            return loaded

        return loaded[classname]


    loadGlobalClass: (file, classname = null, name = null) ->
        file = @_resolvePath file

        if not classname?
            classname = @_findClassname(file)

        if not name?
            name = classname

        window[name] = @loadClass(file, classname)


    _findClassname: (file) ->
        sp = file.match /\/(\w+)$/
        if sp and sp.length > 1
            return sp[1]



    _resolvePath: (path) =>
        if not path?
            return null

        split = path.split '::'

        if split and split.length is 2
            return @resolverPaths[split[0]] + '/' + split[1]

        return path


    debugAlert: (val) =>
        if @isDebug() then alert(val)

    debugLog: (val) =>
        if @isDebug() then console.log(val)

    isDebug: () =>
        host = document.location.hostname.split('.')
        if window.DEBUG and (host[0] is 'dev' or not (host[host.length - 2] is 'myfarms' and host[host.length - 1] is 'com'))
            return true

        return false

    deactivateNavLinks: (exclude = null) =>
        condition = if exclude then ":not(:contains('#{exclude}'))" else ''
        $("#nav_primary_links li#{condition}, #nav_contact_link li").removeClass 'active'
